import { create } from "zustand"

import {
  type SortingOrder,
  type WarehouseAreaOutputList,
  type WarehouseAreaSortField,
  WarehouseListDocument,
  type WarehouseListQuery,
} from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type WarehouseSearchFilters = SearchFilters & {
  field?: WarehouseAreaSortField
  order?: SortingOrder
}

const deduplicateWarehouses = (
  newData: WarehouseAreaOutputList[],
  existingData: WarehouseAreaOutputList[]
): WarehouseAreaOutputList[] => {
  const uniqueIds = new Set(existingData.map((warehouse) => warehouse.warehouseAreaId))
  return [...existingData, ...newData.filter((warehouse) => !uniqueIds.has(warehouse.warehouseAreaId))]
}

export const useWarehousesSearchStore = create(
  createSearchStore<WarehouseAreaOutputList, WarehouseSearchFilters, WarehouseListQuery>({
    documentNode: WarehouseListDocument,
    deduplicateData: deduplicateWarehouses,
    getQueryInput: (filters: WarehouseSearchFilters, offset: number, limit: number) => {
      const { field, order, ...otherFilters } = filters
      return {
        filter: {
          ...otherFilters,
        },
        offset,
        limit,
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.warehouseArea.list.__typename,
      data:
        data.warehouseArea.list.__typename === "WarehouseAreaListSuccess"
          ? (data.warehouseArea.list.warehouseAreas as WarehouseAreaOutputList[])
          : [],
      error:
        data.warehouseArea.list.__typename === "WarehouseAreaListFailure" ? data.warehouseArea.list.error : undefined,
    }),
  })
)
